import { FunctionComponent } from 'react';
import { TagModel } from '../../../services/content/tag/models/TagModel';
import Link from 'next/link';
import { Routes } from '../../../constants/Routes';

type Props = {
    tag: TagModel;
    className?: string;
};

export const Tag: FunctionComponent<Props> = ({ tag, className }) => {
    return (
        <Link href={Routes.openTag(tag.seo.slug)} className={className}>
            #{tag.title}
        </Link>
    );
};
